import { MainImage } from "./HXMobilePage.styles";
import { withLoadTracking } from "./withLoadTracking";
export const MainImageWithLoadTracking = withLoadTracking(MainImage);
